import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=2155ec4d&scoped=true&"
import script from "./Custom.vue?vue&type=script&lang=ts&"
export * from "./Custom.vue?vue&type=script&lang=ts&"
import style0 from "./Custom.vue?vue&type=style&index=0&id=2155ec4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155ec4d",
  null
  
)

export default component.exports